import { render, staticRenderFns } from "./SactinRealTimeTracking.vue?vue&type=template&id=64640280&scoped=true&"
import script from "./SactinRealTimeTracking.vue?vue&type=script&lang=js&"
export * from "./SactinRealTimeTracking.vue?vue&type=script&lang=js&"
import style0 from "./SactinRealTimeTracking.vue?vue&type=style&index=0&id=64640280&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64640280",
  null
  
)

export default component.exports